(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["discontinued-color-bar"] && !Shopify.designMode) return;
  try {
    (function() {
    const bar = document.getElementById('discontinued-color-bar');
    if (!bar) return;

    const textEl = bar.querySelector('.discontinued-color-bar__text');
    if (!textEl) return;

    const raw = bar.getAttribute('data-discontinued-colors') || '[]';
    const initialColor = (bar.getAttribute('data-initial-color') || '').toLowerCase().trim();
    const colorOptionIndexAttr = bar.getAttribute('data-color-option-index');
    const colorOptionIndex = colorOptionIndexAttr !== null ? parseInt(colorOptionIndexAttr, 10) : NaN;

    let map = new Map();

    try {
      const list = JSON.parse(raw);
      list.forEach((item) => {
        if (!item || !item.color || !item.date) return;
        map.set(String(item.color).toLowerCase().trim(), item.date);
      });
    } catch (e) {
      map = new Map();
    }

    function getOrdinal(day) {
      if (day > 3 && day < 21) return 'th';
      const last = day % 10;
      if (last === 1) return 'st';
      if (last === 2) return 'nd';
      if (last === 3) return 'rd';
      return 'th';
    }

    // function formatDate(isoDate) {
    //   const date = new Date(isoDate);
    //   if (Number.isNaN(date.getTime())) return '';
    //   const month = date.toLocaleDateString(undefined, { month: 'short' });
    //   const day = date.getDate();
    //   return `${month} ${day}${getOrdinal(day)}`;
    // }
    function formatDate(isoDate) {
      const date = new Date(isoDate + 'T00:00:00'); 
      
      if (Number.isNaN(date.getTime())) return '';

      // toLocaleDateString ki jagah specific UTC methods use karein
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const month = months[date.getMonth()];
      const day = date.getDate();

      return `${month} ${day}${getOrdinal(day)}`;
    }

    function updateBarForColor(colorRaw) {
      
      if (!colorRaw) {
        bar.hidden = true;
        textEl.textContent = '';
        return;
      }

      const normalized = colorRaw.toLowerCase().trim();     
      const iso = map.get(normalized);

      if (!iso) {
        bar.hidden = true;
        textEl.textContent = '';
        return;
      }

      const formatted = formatDate(iso);
      if (!formatted) {
        bar.hidden = true;
        textEl.textContent = '';
        return;
      }

      textEl.textContent = `${window.product_discontinue_message.text.replace('#Date', formatted)}`;
      bar.hidden = false;
    }

    let currentColor = initialColor;
    
    if (initialColor) {
      updateBarForColor(initialColor);
    } else {
      bar.hidden = true;
    }

    // ============================================
    // SYSTEM 1: For custom dropdown (variant:change event)
    // ============================================
    if (!Number.isNaN(colorOptionIndex)) {
      document.addEventListener('variant:change', function(event) {
        const variant = event.detail && event.detail.variant;
        if (!variant || !Array.isArray(variant.options)) return;

        const option = variant.options[colorOptionIndex];
        if (!option) return;
        
        const normalizedOption = option.toLowerCase().trim();
        if (normalizedOption !== currentColor) {
          currentColor = normalizedOption;
          updateBarForColor(option);
        }
      });
    }

    // ============================================
    // SYSTEM 2: For variant-selects with radio buttons
    // ============================================
    const variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      
      const colorRadios = document.querySelectorAll('input[name*="Color"], input[name*="color"]');
      
      colorRadios.forEach(radio => {
        radio.addEventListener('change', function() {
          const normalizedValue = this.value.toLowerCase().trim();
          if (normalizedValue !== currentColor) {
            currentColor = normalizedValue;
            updateBarForColor(this.value);
          }
        });
      });

      const selectedColorSpan = document.querySelector('legend[class*="form__label"] span[data-selected-value]');
      if (selectedColorSpan) {
        console.log('Found selected color span:', selectedColorSpan); 
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(mutation => {
            if (mutation.type === 'characterData' || mutation.type === 'childList') {
              const color = selectedColorSpan.textContent.trim();
              const normalizedColor = color.toLowerCase().trim();
              if (normalizedColor !== currentColor) {
                currentColor = normalizedColor;
                updateBarForColor(color);
              }
            }
          });
        });
        
        observer.observe(selectedColorSpan, {
          childList: true,
          characterData: true,
          subtree: true
        });
      }

      variantSelects.addEventListener('change', function(event) {
        if (event.target && event.target.matches('input[type="radio"]')) {
          if (event.target.checked) {
            const normalizedValue = event.target.value.toLowerCase().trim();
            if (normalizedValue !== currentColor) {
              currentColor = normalizedValue;
              updateBarForColor(event.target.value);
            }
          }
        }
      });
    }

    // ============================================
    // SYSTEM 3: For custom dropdown navigation
    // ============================================
    document.addEventListener('click', function(event) {
      const dropdownOption = event.target.closest('.dropdown-option');
      if (dropdownOption && !dropdownOption.classList.contains('current')) {
        const label = dropdownOption.getAttribute('data-label');
        if (label) {
          const normalizedLabel = label.toLowerCase().trim();
          if (normalizedLabel !== currentColor) {
            currentColor = normalizedLabel;
            updateBarForColor(label);
          }
        }
      }
      
      const swatchLink = event.target.closest('.swatch a');
      if (swatchLink) {
        const color = swatchLink.getAttribute('title');
        if (color) {
          const normalizedColor = color.toLowerCase().trim();
          if (normalizedColor !== currentColor) {
            currentColor = normalizedColor;
            updateBarForColor(color);
          }
        }
      }
    });

  })();
  } catch(e) { console.error(e); }
})();

})();
